import { render, staticRenderFns } from "./TreatmentArchivesModal__Style#Drawer.vue?vue&type=template&id=73184f0f&scoped=true&"
import script from "./TreatmentArchivesModal__Style#Drawer.vue?vue&type=script&lang=js&"
export * from "./TreatmentArchivesModal__Style#Drawer.vue?vue&type=script&lang=js&"
import style0 from "./TreatmentArchivesModal__Style#Drawer.vue?vue&type=style&index=0&id=73184f0f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73184f0f",
  null
  
)

export default component.exports